import { useQuery } from '@tanstack/react-query';
import { fetchFeaturedEvent } from '../api/events.public.api';
import { publicEventsKeys } from './events.keys';

/**
 * The event the backend currently resolves as featured, or `null` when the queue
 * is empty or every entry is in the past.
 *
 * `null` is a valid, successful result, not an error state - callers render
 * nothing (authenticated page) or fall back to a standard card (public section)
 * rather than showing a failure.
 */
export function useFeaturedEvent() {
  return useQuery({
    queryKey: publicEventsKeys.featured(),
    queryFn: fetchFeaturedEvent,
  });
}
